import { createSelector } from 'reselect'

import {
  fetchingStatusesSelector,
  isAuthenticatedSelector,
  isBoostrappedSelector,
  isRealtimeSubscribedSelector,
  hasRealtimeConnectedOnceSelector,
  selectIsInboxBootstrapped,
} from 'selectors/app/base'
import {
  selectCurrentPath,
  selectIsInInbox,
  selectIsInChat,
} from 'selectors/location'
import { selectStoredPinnedSearches } from 'selectors/pinned_searches/base'

import { constructSearchQueryObject } from 'util/search'

export const currentPathSelector = selectCurrentPath

export const selectIsInvalidPath = createSelector(
  currentPathSelector,
  path => path === '/tickets' || path === '/tickets/'
)

export const shouldSubscribeToRealtimeSelector = createSelector(
  isAuthenticatedSelector,
  isBoostrappedSelector,
  isRealtimeSubscribedSelector,
  fetchingStatusesSelector,
  selectIsInInbox,
  selectIsInChat,
  hasRealtimeConnectedOnceSelector,
  (
    authenticated,
    bootstrapped,
    subscribed,
    statuses,
    inInbox,
    inChat,
    hasConnectedOnce
  ) => {
    return (
      (inInbox || inChat) &&
      authenticated &&
      (bootstrapped || inChat) &&
      !subscribed &&
      !statuses.subscribeRealtime &&
      !hasConnectedOnce
    )
  }
)

export const shouldFetchInboxBootstrapData = createSelector(
  isAuthenticatedSelector,
  fetchingStatusesSelector,
  selectIsInInbox,
  selectIsInboxBootstrapped,
  (authenticated, statuses, inInbox, isInboxBoostrapped) => {
    return (
      inInbox && authenticated && !isInboxBoostrapped && !statuses.fetchAppData
    )
  }
)

export const selectStoredPinnedSearchQueries = createSelector(
  selectStoredPinnedSearches,
  pinned => {
    return pinned && pinned.map(pin => constructSearchQueryObject(pin.query))
  }
)
